import { lazy } from 'react';

/** Загружает форму шаблона промокодов */
export const PromoCodeTemplateFormPageAsync = lazy(() => import('./PromoCodeTemplateFormPage'));
